import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionHeader,
  AccordionContent
} from "src/components";
import { inject } from "mobx-react";
import React, { useEffect, useState } from "react";
import Box from "react-raster";
import { Heading, Input, MultiSelect, Option } from "src/components";
import { UserSelect } from "src/components/userSelect";
import { theme } from "src/config";
import { UserStore } from "src/stores";

export const InputSection = inject("userStore")(
  (props: { userStore?: UserStore }) => {
    const [input, setInput] = useState("");
    const [number, setNumber] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [showEmailError, setShowEmailError] = useState(false);

    const [acc, setAcc] = useState("hello");

    const [password, setPassword] = useState("");
    const [showPasswordError, setShowPasswordError] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [showConfirmPasswordError, setShowConfirmPasswordError] =
      useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [selected, setSelected] = React.useState<Option>(undefined);
    const [selectedUser, setSelectedUser] = React.useState<Option>(undefined);
    const [selectedUsers, setSelectedUsers] = React.useState<Option[]>([]);

    const handlNumberChange = (value: string): void => {
      setNumber(value);
    };

    const handleEmailChange = (value: string): void => {
      setEmail(value);
    };

    const handlePasswordChange = (value: string): void => {
      setPassword(value);
    };

    const handlePasswordConfirmChange = (value: string): void => {
      setConfirmPassword(value);
    };

    const handleEmailValidation = (): void => {
      const validEmail =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (validEmail.test(email) || email === "") {
        setShowEmailError(false);
      } else {
        setShowEmailError(true);
      }
    };

    useEffect(() => {
      setShowEmailError(false);
    }, [email]);

    const handlePasswordValidation = (): void => {
      const validPassword =
        /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))$/;
      if (validPassword.test(password) || password === "") {
        setShowPasswordError(false);
      } else {
        setShowPasswordError(true);
      }
    };

    useEffect(() => {
      setShowPasswordError(false);
      setShowConfirmPasswordError(false);
    }, [password, confirmPassword]);

    const handleConfirmValidation = (): void => {
      if (
        confirmPassword === password ||
        confirmPassword === "" ||
        password === ""
      ) {
        setShowConfirmPasswordError(false);
      } else {
        setShowConfirmPasswordError(true);
      }
    };

    useEffect(() => {
      setShowPasswordError(false);
    }, [confirmPassword]);

    const togglePasswordVisiblity = () => {
      setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisiblity = () => {
      setShowConfirmPassword(!showConfirmPassword);
    };

    return (
      <Box
        colspan={2}
        gridColumnGap={theme.layout.gutterSmall}
        gridRowGap={theme.layout.gutter}
      >
        <Heading weight="normal" type="h3" color="black">
          Inputs
        </Heading>
        <Box cols={2}>
          <hr />
        </Box>
        <Input
          type="number"
          label="Number"
          id="text"
          required={true}
          value={number}
          helperText="I have a tip for you!"
          onChange={(value) => setNumber(value)}
        />
        <Input
          type="text"
          label="Text"
          id="text"
          required={true}
          value={input}
          helperText="I have a tip for you!"
          onChange={(value) => setInput(value)}
        />
        <Input
          type="email"
          label="Email"
          id="email"
          value={email}
          secondaryIconId="eye"
          iconId="close"
          onChange={(value) => setEmail(value)}
          showError={showEmailError}
          onBlur={handleEmailValidation}
          errorMessage="Add a valid email"
          icons={[
            {
              iconId: "close"
            },
            {
              iconId: "eye"
            }
          ]}
        />
        <MultiSelect
          options={[
            { value: "something1", label: "Label1" },
            { value: "something2", label: "Label2" },
            { value: "something3", label: "Label3" }
          ]}
          selected={selected ? [selected] : []}
          onChange={setSelected}
          singleSelect
          showLoadMore
          onLoad={() => {}}
          label="Label"
        />
        <UserSelect
          options={props.userStore.getItems.map((u) => ({
            label: u.getFullName,
            value: u
          }))}
          selected={selectedUser ? [selectedUser] : []}
          onChange={setSelectedUser}
          singleSelect
          label="Label"
        />
        <Input
          type={showPassword ? "text" : "password"}
          label="Password"
          id="password"
          value={password}
          onChange={(value) => setPassword(value)}
          showError={showPasswordError}
          onBlur={handlePasswordValidation}
          icons={[
            {
              iconId: showPassword ? "eye" : "eyeClosed",
              action: togglePasswordVisiblity
            }
          ]}
          errorMessage="Enter a valid password"
        />
        <Box style={{ marginBottom: 10 }}>
        <Heading weight="normal" type="h3" color="black">
          Accordion
        </Heading>
        <hr/>
        <Accordion type="single"  collapsible>
    <AccordionItem value="item-1">
      <AccordionTrigger>Is it accessible?</AccordionTrigger>
      <AccordionContent>Yes. It adheres to the WAI-ARAI design pattern.</AccordionContent>
    </AccordionItem>

    <AccordionItem value="item-2">
      <AccordionTrigger>Is it unstyled?</AccordionTrigger>
      <AccordionContent>
        Yes. It's unstyled by default, giving you freedom over the look and feel.
      </AccordionContent>
    </AccordionItem>

    <AccordionItem value="item-3">
      <AccordionTrigger>Can it be animated?</AccordionTrigger>
      <AccordionContent>
        Yes! You can animate the Accordion with CSS or JavaScript.
      </AccordionContent>
    </AccordionItem>
  </Accordion>
        </Box>
      </Box>
    );
  }
);
